import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { ImprintPage } from '../../api/api-types';

export const actions = createActionGroup({
    source: 'imprint',
    events: {
        'Load Dealer Imprint': emptyProps(),
        'Load Dealer Imprint Overlay By Slug': props<{ slug: string }>(),
        'Load Dealer Imprint Success': props<{ imprint: ImprintPage }>(),
        'Load Dealer Imprint Failure': props<{ error: string }>(),
    },
});
